module.exports = __webpack_public_path__ + "static/img/pickup-doublecab-bluegrey.07564a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-doublecab-bluegrey.svg
// module id = r5jJ
// module chunks = 82